import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=c63dec8c"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=c63dec8c&prod&lang=css"
import style1 from "./ForgotPassword.vue?vue&type=style&index=1&id=c63dec8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports